module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("83C6Z"))).then(() => parcelRequire('hEqeo'));